import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { QueryProvider } from "@shared/providers/QueryProvider";
import { PublicLayout } from "@public/components/layout";
import { Home, Categories, Products, ProductDetail, Subcategories, Search, Contact } from "@public/pages";
import { NotificationContainer } from "@shared/components";
import { useNotifications } from "@shared/hooks";
import {
  Login,
  Dashboard,
  AdminProductosPage,
  AdminCategoriasPage,
  AdminCatalogosPage,
  AdminCarouselsPage,
  AdminHistorialPage,
} from "@admin/pages";
import { ProtectedRoute, PublicRoute, AdminLayout } from "@admin/components";

function AppContent() {
  const { notifications, removeNotification } = useNotifications();

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="/catalog/:slugCatalogo" element={<Categories />} />
            <Route
              path="/catalog/:slugCatalogo/categoria/:categoriaSlug/subcategorias"
              element={<Subcategories />}
            />
            <Route
              path="/catalog/:slugCatalogo/categoria/:categoriaSlug/subcategoria/:subcategoriaSlug"
              element={<Products />}
            />
            <Route
              path="/catalog/:slugCatalogo/categoria/:categoriaSlug"
              element={<Products />}
            />
            <Route
              path="/catalogo/:slugCatalogo/categoria/:categoriaSlug/producto/:productSlug"
              element={<ProductDetail />}
            />
            {/* Ruta simple para productos desde búsqueda */}
            <Route
              path="/producto/:productSlug"
              element={<ProductDetail />}
            />
            {/* Página de resultados de búsqueda */}
            <Route
              path="/search"
              element={<Search />}
            />
            {/* Página de contacto */}
            <Route
              path="/contact"
              element={<Contact />}
            />
            {/* Aquí irán más rutas públicas */}
          </Route>

          {/* Rutas del admin */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          {/* Rutas protegidas del admin */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="productos" element={<AdminProductosPage />} />
            <Route path="categorias" element={<AdminCategoriasPage />} />
            <Route path="catalogos" element={<AdminCatalogosPage />} />
            <Route path="carrusels" element={<AdminCarouselsPage />} />
            <Route path="historial" element={<AdminHistorialPage />} />
            {/* TODO: Agregar más rutas del admin cuando estén implementadas */}
          </Route>
        </Routes>
      </Router>
      <NotificationContainer
        notifications={notifications}
        onRemove={removeNotification}
      />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <QueryProvider>
        <AppContent />
      </QueryProvider>
    </HelmetProvider>
  );
}

export default App;
